import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=7129a205&"
import script from "./BackToTop.vue?vue&type=script&lang=js&"
export * from "./BackToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports